module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "id": "_Слой_2",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 85 85"
    }
  }, [_c('g', {
    attrs: {
      "id": "_Слой_1-2"
    }
  }, [_c('g', [_c('circle', {
    staticClass: "cls-2",
    attrs: {
      "cx": "42.5",
      "cy": "42.5",
      "r": "42.5"
    }
  }), _c('g', [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M21.94,61.16c0,3.09,0,6.19,0,9.28,0,.51-.24,.86-.66,1-.39,.13-.83,0-1.09-.31-.2-.25-.23-.55-.23-.86,0-2.4,0-4.8,0-7.2,0-.35-.07-.47-.45-.47-2.28-.01-4.05-1.95-4.02-4.17,.04-2.97-.05-5.94,.05-8.91,.13-4,3.52-7.53,7.51-7.84,2.49-.19,4.99-.17,7.48,0,1.45,.1,2.66,.85,3.77,1.78,1.13,.94,2.09,2.01,2.9,3.24,.67,1.02,.98,2.12,.97,3.34-.01,2.8,0,5.6,0,8.41,0,2.33-1.65,4.05-3.98,4.15-.38,.02-.47,.11-.47,.49,.02,2.41,.01,4.83,0,7.24,0,.88-.63,1.37-1.38,1.08-.34-.13-.53-.39-.59-.74-.02-.15-.02-.3-.02-.46,0-6.09,0-12.18,0-18.27,0-.6,.27-.97,.77-1.08,.44-.1,.91,.14,1.11,.55,.11,.23,.11,.48,.11,.73,0,2.68,.01,5.36-.01,8.03,0,.43,.16,.48,.51,.45,1.09-.1,1.95-.92,1.95-1.97,.02-2.95,.04-5.91,0-8.86-.02-1.65-.71-3.06-1.86-4.24-1.27-1.32-2.85-1.93-4.66-1.95-1.87-.03-3.75-.02-5.62,0-3.66,.03-6.53,2.91-6.54,6.57,0,2.76,0,5.52,0,8.28,0,1.25,.78,2.07,1.99,2.18,.35,.03,.48-.04,.48-.43-.02-2.68-.01-5.35,0-8.03,0-.17,0-.34,.03-.5,.09-.51,.55-.86,1.04-.82,.53,.04,.91,.44,.91,1,0,1.9,0,3.8,0,5.7,0,1.21,0,2.41,0,3.62Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M45.95,60.53c-2.15,.07-4.25-.24-6.33-.8-.26-.07-.39-.14-.32-.47,.08-.4,.07-.83,.05-1.24-.02-.35,.04-.44,.42-.33,2.81,.87,5.68,1.11,8.59,.78,4.56-.52,8.56-2.32,11.97-5.39,3.87-3.49,6.22-7.84,6.96-13,.65-4.52-.09-8.84-2.18-12.91-.15-.28-.14-.45,.1-.66,.33-.29,.65-.61,.94-.94,.2-.22,.27-.17,.4,.06,1.09,1.99,1.92,4.09,2.38,6.32,1.33,6.44,.32,12.49-3.31,17.99-3.84,5.81-9.27,9.26-16.16,10.38-.59,.1-1.18,.17-1.78,.21-.58,.03-1.16,0-1.75,0Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M60.87,26.25c-.76,0-1.53,.01-2.29,0-.3,0-.52,.08-.73,.29-3.2,3.21-6.41,6.42-9.61,9.63-.49,.49-.98,.98-1.47,1.47-.49,.48-1.09,.52-1.51,.11-.42-.41-.38-1.02,.1-1.51,3.65-3.65,7.29-7.3,10.95-10.94,.3-.3,.46-.59,.45-1.04-.03-1.51,0-3.02-.02-4.54,0-.37,.12-.67,.38-.93,1.63-1.63,3.26-3.25,4.88-4.88,.33-.34,.71-.48,1.17-.29,.46,.19,.62,.58,.62,1.04,0,1.37,.01,2.75,0,4.12,0,.34,.08,.45,.43,.44,1.36-.02,2.72,0,4.08-.01,.4,0,.74,.1,.98,.43,.32,.44,.23,.94-.25,1.41-1.28,1.29-2.56,2.58-3.86,3.85-1.69,1.66-.92,1.31-3.31,1.35-.33,0-.67,0-1,0Zm.94-9.26c-.18,.03-.27,.14-.36,.24-.72,.76-1.47,1.5-2.22,2.23-.2,.19-.51,.33-.51,.71,.01,1.25,.01,2.5,0,3.74,0,.26,.05,.36,.34,.36,1.22-.02,2.44-.01,3.66,0,.2,0,.33-.06,.47-.2,.84-.85,1.69-1.68,2.53-2.53,.09-.09,.24-.15,.22-.35-1.01,0-2.02,0-3.03,0-.75,0-1.09-.35-1.1-1.1,0-1.02,0-2.05,0-3.1Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M26.2,41.17c-2.1-.08-4.18-1.3-5.58-3.64-1.95-3.25-1.42-7.61,1.2-10.26,2.99-3.03,8.03-2.72,10.64,.65,2.8,3.61,2.24,8.98-1.23,11.74-1.28,1.02-2.75,1.53-5.04,1.52Zm.66-1.98c1.2,0,2.26-.39,3.19-1.14,2.39-1.92,2.93-5.74,1.21-8.41-1.97-3.06-6.03-3.34-8.39-.58-1.88,2.19-1.9,5.93-.05,8.16,1.05,1.27,2.39,1.95,4.04,1.96Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M58.58,27.41c.92,1.17,1.59,2.39,2.11,3.69,.68,1.69,1.08,3.44,1.12,5.26,.04,1.79-.14,3.55-.68,5.28-1.54,4.89-4.69,8.28-9.42,10.18-2.12,.85-4.38,.9-6.64,.78-1.71-.09-3.4-.31-5.03-.85-.83-.27-.67-.11-.69-.93-.01-.49,0-.99,0-1.53,.63,.28,1.22,.58,1.84,.81,8.24,2.96,17.08-2.22,18.47-10.87,.58-3.62-.17-6.97-2.23-10.01-.2-.29-.19-.45,.06-.68,.38-.35,.71-.74,1.08-1.13Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M52.41,33.61c2.35,4.31-.38,9.87-5.14,10.63-3.32,.53-6.44-.98-7.86-3.94-2.5-5.22,1.37-10.56,6.49-10.57,1.1,0,2.14,.22,3.14,.67,.23,.1,.36,.2,.09,.4-.07,.05-.12,.12-.18,.18-.32,.32-.61,.72-.98,.95-.42,.26-.86-.12-1.29-.18-3.11-.44-5.99,2.04-6.05,5.18-.06,2.96,2.21,5.13,4.64,5.41,2.9,.33,5.37-1.49,5.93-4.33,.17-.84,.12-1.69-.15-2.5-.09-.28-.04-.45,.17-.65,.4-.38,.77-.79,1.19-1.23Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M26.36,24.01c.85-1.29,1.76-2.41,2.78-3.45,1.65-1.69,3.5-3.12,5.6-4.21,1.52-.79,3.09-1.45,4.76-1.92,2.51-.71,5.05-1.02,7.64-.9,3.65,.17,7.07,1.16,10.26,2.93,.19,.1,.25,.17,.07,.35-.36,.34-.72,.7-1.06,1.06-.15,.15-.26,.18-.46,.07-3.43-1.79-7.09-2.6-10.95-2.43-1.5,.07-2.97,.3-4.43,.65-1.26,.31-2.48,.73-3.63,1.28-3.18,1.51-5.9,3.62-8.04,6.44-.17,.23-.32,.3-.62,.24-.6-.14-1.21-.14-1.91-.12Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M34.55,29.08c-.3-.62-.6-1.17-.99-1.65-.18-.23,0-.32,.1-.45,2.07-2.51,4.65-4.28,7.78-5.16,4.94-1.39,9.54-.62,13.78,2.3,.3,.21,.32,.32,.05,.56-.37,.33-.66,.87-1.09,1-.42,.12-.8-.42-1.21-.65-6.37-3.58-13.96-1.96-18.31,3.92-.02,.03-.05,.07-.11,.14Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M25.85,66.51c0-1.25,0-2.5,0-3.74,0-.7,.38-1.13,1-1.12,.61,0,.99,.46,.99,1.14,0,2.54,0,5.08,0,7.61,0,.46-.17,.82-.6,1-.39,.17-.76,.1-1.08-.19-.24-.22-.31-.51-.31-.83,0-1.29,0-2.58,0-3.87h0Z"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59bc2cbc","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIcon/iconsTemplate/contents/dashboard/okonchivshikhObucheniye.vue
// module id = 02a90c0291ca1983eddf
// module chunks = 89